import { createGlobalStyle } from 'styled-components';

/** Sidebar rail widths from Sidebar_v2's ContentWrapper defaults, plus a gap to the panel. */
const EXPANDED_LEFT = '256px'; // 240px (15rem) expanded rail + 16px gap
const COLLAPSED_LEFT = '96px'; // 80px (5rem) collapsed rail + 16px gap

/**
 * Anchors the Messenger panel next to the sidebar's Support button in both expanded and
 * collapsed states. Intercom's default position (`left: 256px`) only matches the expanded
 * rail width by coincidence, so this overrides `left` explicitly for both states via the
 * `expanded` prop; `bottom`/`top`/`right` are left alone since Intercom's default already
 * looks right there (confirmed visually, FRONTEND-799). Targets `.intercom-messenger-frame`
 * -- Intercom's stable class, not the hashed Emotion class alongside it -- with the
 * `#intercom-container` ID prefix guaranteeing this outranks Intercom's own `!important` rule
 * (see AuthContainerView's `SupportWidgetPositionOverride` for the same technique). If the
 * panel reverts to Intercom's default position, re-verify these selectors via devtools.
 */
export const SupportWidgetPositionOverride = createGlobalStyle<{ isSidebarCollapsed: boolean }>`
  #intercom-container .intercom-messenger-frame {
    left: ${({ isSidebarCollapsed }) => (isSidebarCollapsed ? COLLAPSED_LEFT : EXPANDED_LEFT)} !important;
  }
`;
